import { COUNTRIES } from '@retracedgmbh/modules/countries/contracts';

/** Every country as a dropdown option: `key` is the ISO alpha-2 code. */
export const COUNTRY_OPTIONS = COUNTRIES.map(country => ({
  key: country.countryCode,
  label: country.countryNameEn,
  name: country.countryNameEn,
}));

/** Every country as a `{ value, label }` select option, sorted by name. */
export const COUNTRY_VALUE_OPTIONS = COUNTRIES.map(country => ({
  value: country.countryCode,
  label: country.countryNameEn,
})).sort((a, b) => a.label.localeCompare(b.label));
